
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  troughListButtonSelect: {
    id: "TroughListButtonSelect.select",
    defaultMessage: "Select trough",
  },
  troughListButtonClose: {
    id: "TroughListButtonClose.close",
    defaultMessage: "Close trough menu",
  },
  troughListButtonFilterOptions: {
    id: "TroughListButtonFilterOptions.filter",
    defaultMessage: "Show Filter Options",
  },
  troughListSorryMsg: {
    id: "TroughListSorryMsg.message",
    defaultMessage: "Sorry, we didn't found any Trough matching your selected filter options.",
  },
});

export default MESSAGES;